import { render } from "./UnsubscribedView.vue?vue&type=template&id=a6215cc8"
import script from "./UnsubscribedView.vue?vue&type=script&lang=js"
export * from "./UnsubscribedView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__